import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserService } from '../services/user.service';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { NotifyService } from "@core/services/notify.service";

@Injectable({
  providedIn: 'root'
})
export class GroupGuard  {
  constructor(
    private userService: UserService,
    private notifyService: NotifyService
  ) {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (!route?.data?.accessGroup) {
      console.warn('Configure router access groups!')
      return false;
    }

    return this.userService.getAuthUser$().pipe(
      filter(Boolean),
      take(1),
      map((authUser: any) => {
        if (!authUser) {
          return false;
        }
// authUser['cognito:groups'] = 'admin_tech'
        if (this.checkAccessGroups(authUser?.['cognito:groups'], route.data.accessGroup)) {
          return true;
        }

        this.notifyService.errorMessage(`NOTIFICATIONS.MESSAGES.NO_AUTH_ROLE`);
        return false;
      })
    );
  }


  private checkAccessGroups(groups: string[], accessGroups: string | string[]): boolean {
    if (!groups) {
      return false;
    }

    if (Array.isArray(accessGroups)) {
      return !!accessGroups.find(accessGroup => this.checkAccessGroup(groups, accessGroup))
    }

    return this.checkAccessGroup(groups, accessGroups)
  }

  private checkAccessGroup(groups: string[], accessGroup: string): boolean {
    return groups.includes(accessGroup);
  }
}
